import React from "react";
import { Container } from "react-bootstrap";

interface ListingPageContainerProps {
  children: React.ReactNode;
  className?: string;
  outerStyle?: React.CSSProperties;
  innerStyle?: React.CSSProperties;
  fluid?: boolean;
  useFragment?: boolean;
}

const ListingPageContainer: React.FC<ListingPageContainerProps> = ({
  children,
  className = "",
  outerStyle,
  innerStyle,
  fluid = true,
  useFragment = true,
}) => {
  const defaultOuterStyle: React.CSSProperties = {
    backgroundColor: "#e9ecef",
    height: "100vh",
    boxSizing: "border-box",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    paddingTop: "calc(var(--vz-header-height, 56px) + 4px)",
    paddingBottom: "6px",
    paddingLeft: "0.75rem",
    paddingRight: "0.75rem",
    marginTop: 0,
    ...outerStyle,
  };

  const defaultInnerStyle: React.CSSProperties = {
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 0 15px rgba(0,0,0,0.1)",
    padding: "10px 14px 10px",
    flex: "0 1 auto",
    maxHeight: "100%",
    minHeight: 0,
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    ...innerStyle,
  };

  const content = (
    <div
      className={`page-content mecord-listing-page ${className}`.trim()}
      style={defaultOuterStyle}
    >
      <Container fluid={fluid} style={defaultInnerStyle}>
        {children}
      </Container>
    </div>
  );

  if (useFragment) {
    return <>{content}</>;
  }

  return content;
};

export default ListingPageContainer;
